module.exports = __webpack_public_path__ + "img/undraw.772e8f6c.svg";